import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '..';

@Component({
    selector: 'btn-sort-and-filter',
    templateUrl: './button-sort-and-filter.component.html',
    styleUrls: ['./button-sort-and-filter.component.scss'],
    imports: [TranslateModule, ButtonComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortAndFilterButtonComponent {
    id = input.required<string>();

    filterOnly = input<boolean>(false);
    disabled = input<boolean>(false);
    size = input<'small' | 'large' | undefined>(undefined);

    onClick = output<MouseEvent>();
}
